// extracted by mini-css-extract-plugin
export default {"button":"style_button__KHtO8","poison":"style_poison__pynKn","rotate":"style_rotate__t0gUB"};